import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, User, Tag } from 'lucide-react';
import './BlogCard.css';

const BlogCard = ({ post }) => {
  const { image, date, author, category, title, slug } = post;

  return (
    <div className="blog-card">
      <div className="blog-card-image-wrapper">
        <img src={image} alt={title} className="blog-card-image" />
        <div className="date-badge">
          <span className="date-day">{date.day}</span>
          <span className="date-month">{date.month}</span>
        </div>
      </div>
      <div className="blog-card-content">
        <div className="blog-meta">
          <span className="meta-item">
            <User size={14} /> By {author}
          </span>
          <span className="meta-item">
            <Tag size={14} /> {category}
          </span>
        </div>
        <h3 className="blog-title">
          <Link to={`/blogs/${slug}`}>{title}</Link>
        </h3>
        <Link to={`/blogs/${slug}`} className="read-more-link">
          Read More <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
